import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {Formik} from 'formik'
import {UserIcon, EditIcon} from '../../../icons'
import Input from '../../core/input'
import {SimpleBlueButton} from '../../core/button'
import ButtonLoader from '../../core/button/ButtonLoader'
import {usernameSchema} from '../../../utils/validation'
import {updateCustomerUsername} from '../../../stores/customer-settings'
import localStorageManager from '../../../utils/localStorageManager'
import {trimStringValues} from '../../../utils/text'

const AccountSection = ({text}) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [editMode, setEditMode] = useState(false)
    const initialFormValues = {
        email: localStorageManager.get('customer')?.email
    }

    const handleSubmit = async(values, {setFieldError}) => {
        await dispatch(updateCustomerUsername(trimStringValues(values), setFieldError, navigate))
    }

    return (
        <div className='security-card'>
            <div className='security-card-content'>
                <div className='security-icon security-icon--neutral'>
                    <UserIcon color='currentColor'/>
                </div>
                <div className='security-info'>
                    <h3 className='security-card-title'>{text.account_title}</h3>
                    <p className='security-card-description'>{text.account_description}</p>
                </div>
            </div>
            <div className='security-card-body'>
                <Formik
                    initialValues={initialFormValues}
                    onSubmit={handleSubmit}
                    validationSchema={usernameSchema}
                    validateOnBlur={false}
                    validateOnChange={false}
                >
                    {({values, errors, handleChange, handleSubmit: submitForm, resetForm, isSubmitting}) => (
                        <form onSubmit={submitForm}>
                            <div className='security-account-row'>
                                <div className='security-field'>
                                    <Input
                                        value={values.email}
                                        placeholder={text.username}
                                        name='email'
                                        onChange={handleChange}
                                        error={errors.email}
                                        isReadonly={!editMode}
                                    />
                                </div>
                                {!editMode && (
                                    <SimpleBlueButton
                                        outline
                                        className='security-edit-button'
                                        onClick={() => setEditMode(true)}
                                    >
                                        <EditIcon className='security-edit-icon'/>
                                        {text.edit}
                                    </SimpleBlueButton>
                                )}
                            </div>
                            {editMode && (
                                <div className='security-account-actions'>
                                    <SimpleBlueButton
                                        outline
                                        onClick={() => {
                                            resetForm()
                                            setEditMode(false)
                                        }}
                                    >
                                        {text.cancel}
                                    </SimpleBlueButton>
                                    <SimpleBlueButton
                                        type='submit'
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting && <ButtonLoader/>}
                                        {text.update_username}
                                    </SimpleBlueButton>
                                </div>
                            )}
                        </form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default AccountSection
